import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    // {
    //     id: 1,
    //     label: 'MENUITEMS.MENU.TEXT',
    //     isTitle: true
    // },

    {
        id: 2,
        label: 'MENUITEMS.HOME.TEXT',
        link: '/epage/dashboard',
        icon: 'bx-home-circle',
    },
    {
        id: 3,
        isLayout: true
    },
    {
        id: 4,
        label: 'MENUITEMS.SELL.TEXT',
        icon: 'bx-border-all',
        subItems: [
            {
                id: 5,
                label: 'MENUITEMS.SELL.LIST.DEFAULT',
                link: 'sell/webregister',
                parentId: 4
            },
            {
                id: 6,
                label: 'MENUITEMS.SELL.LIST.OPENCLOSE',
                link: 'sell/registerclose',
                parentId: 4
            },
            {
                id: 7,
                label: 'MENUITEMS.SELL.LIST.SELLHISTORY',
                link: 'sell/saleshistory',
                parentId: 4
            },
            {
                 id: 10,
                label: 'MENUITEMS.SELL.LIST.PENDINGINVOICESTOPUSH',
                link: 'sell/pendinginvoicestopush',
                parentId: 4
            },
            // {
            //     id: 8,
            //     label: 'MENUITEMS.SELL.LIST.KOT',
            //     link: 'sell/kot',
            //     parentId: 4
            // },
            // {
            //     id: 9,
            //     label: 'MENUITEMS.SELL.LIST.KOTHISTORY',
            //     link: 'sell/kothistory',
            //     parentId: 4
            // },
            // {
            //     id: 8,
            //     label: 'Quotation',
            //     link: 'sell/quotationregister',
            //     parentId: 4
            // },
            {
                id: 8,
                label: 'MENUITEMS.SELL.LIST.SELLADVANCE',
                link: 'sell/selladvance',
                parentId: 4
            },
            {
                id: 9,
                label: 'MENUITEMS.SELL.LIST.SALESADVANCEHISTORY',
                link: 'sell/selladvancehistory',
                parentId: 4
            },
        ]
    },
    {
        id: 130,
        label: 'MENUITEMS.KOT.TEXT',
        icon: 'bxs-store',
        subItems: [
            {
                id: 1,
                label: 'MENUITEMS.KOT.LIST.KOTDashboard',
                link: '/epage/dashboards/kot',
                parentId: 130
            },
            {
                id: 3,
                // label: 'MENUITEMS.SELL.LIST.KOT',
                label: 'MENUITEMS.KOT.LIST.KitchenOrderTicket',
                link: 'sell/kot',
                parentId: 130
            },
            {
                id: 4,
                // label: 'MENUITEMS.SELL.LIST.KOTHISTORY',
                label: 'MENUITEMS.KOT.LIST.KOTHistory',
                link: 'sell/kothistory',
                parentId: 130
            },
            {
                id: 2,
                label: 'MENUITEMS.KOT.LIST.TableMaster',
                link: 'setup/TableMaster',
                parentId: 130
            },

        ]
    },
    {
        id: 9,
        isLayout: true
    },
    {
        id: 10,
        label: 'MENUITEMS.REPORTING.TEXT',
        icon: 'bxs-report',
        subItems: [
            {
                id: 11,
                label: 'MENUITEMS.REPORTING.LIST.RetailDashboard',
                link: 'reporting/dashboard',
                parentId: 10
            },
            {
                id: 12,
                label: 'MENUITEMS.REPORTING.LIST.SalesReports',
                link: 'reporting/salesreport',
                parentId: 10
            },
            {
                id: 13,
                label: 'MENUITEMS.REPORTING.LIST.InventoryReports',
                link: 'reporting/inventoryreport',
                parentId: 10
            },
            {
                id: 14,
                label: 'MENUITEMS.REPORTING.LIST.PaymentReports',
                link: 'reporting/paymentreport',
                parentId: 10
            },
            {
                id: 14,
                label: 'MENUITEMS.REPORTING.LIST.Mostfrequentlyproduct',
                link: 'reporting/mostfrequentlyproduct',
                parentId: 10
            },
            {
                id: 15,
                label: 'MENUITEMS.REPORTING.LIST.StoreCreditReports',
                link: 'reporting/storecreditreports',
                parentId: 10
            },
            {
                id: 15,
                label: 'MENUITEMS.REPORTING.LIST.RegisterClosures',
                link: 'reporting/registerclosure',
                parentId: 10
            },
            {
                id: 15,
                label: 'MENUITEMS.REPORTING.LIST.TaxReport',
                link: 'reporting/taxreport',
                parentId: 10
            }


        ]
    },
    {
        id: 16,
        isLayout: true
    },
    {
        id: 17,
        label: 'MENUITEMS.CATALOG.TEXT',
        icon: 'bx-menu',
        subItems: [
            {
                id: 18,
                label: 'MENUITEMS.CATALOG.LIST.Products',
                link: 'catalog/product',
                parentId: 17
            },
            {
                id: 19,
                label: 'MENUITEMS.CATALOG.LIST.Promotions',
                link: 'catalog/promotion',
                parentId: 17
            },

            {
                id: 21,
                label: 'MENUITEMS.CATALOG.LIST.Brands',
                link: 'catalog/brand',
                parentId: 17
            },
            {
                id: 22,
                label: 'MENUITEMS.CATALOG.LIST.Suppliers',
                link: 'catalog/supplier',
                parentId: 17
            },
            {
                id: 23,
                label: 'MENUITEMS.CATALOG.LIST.ProductTags',
                link: 'catalog/producttag',
                parentId: 17
            },
            {
                id: 24,
                label: 'MENUITEMS.CATALOG.LIST.ProductTypes',
                link: 'catalog/producttype',
                parentId: 17
            },
            {
                id: 24,
                label: 'MENUITEMS.CATALOG.LIST.Attribute',
                link: 'catalog/attribute',
                parentId: 17
            }

        ]
    },
    {
        id: 25,
        isLayout: true
    },
    {
        id: 26,
        label: 'MENUITEMS.INVENTORY.TEXT',
        icon: 'bxs-store',
        subItems: [
            {
                id: 27,
                label: 'MENUITEMS.INVENTORY.LIST.ReceiveStock',
                link: 'inventory/stock-control',
                parentId: 26
            },
            {
                id: 28,
                label: 'MENUITEMS.INVENTORY.LIST.Expense',
                link: 'inventory/expense',
                parentId: 26
            },
            {
                id: 29,
                label: 'MENUITEMS.INVENTORY.LIST.PurchaseDashboard',
                link: 'inventory/inventory-dashboard',
                parentId: 26
            },



        ]
    },
    {
        id: 28,
        isLayout: true
    },
    {
        id: 29,
        label: 'MENUITEMS.CUSTOMERS.TEXT',
        icon: 'bxs-user-circle',
        subItems: [
            {
                id: 30,
                label: 'MENUITEMS.CUSTOMERS.LIST.Customers',
                link: 'customers/my-customer/0',
                parentId: 29
            },
            {
                id: 31,
                label: 'MENUITEMS.CUSTOMERS.LIST.Groups',
                link: 'customers/customergroup',
                parentId: 29
            },

        ]
    },
    {
        id: 32,
        isLayout: true
    },
    {
        id: 33,
        label: 'MENUITEMS.SETUP.TEXT',
        icon: 'bxs-analyse',
        subItems: [
            {
                id: 34,
                label: 'MENUITEMS.SETUP.LIST.General',
                link: 'setup/general',
                parentId: 33
            },
            // {
            //     id: 35,
            //     label: 'MENUITEMS.SETUP.LIST.Billing',
            //     link: 'setup/billing',
            //     parentId: 33
            // },
            {
                id: 36,
                label: 'MENUITEMS.SETUP.LIST.OutletsandRegisters',
                link: 'setup/outlets_and_registers',
                parentId: 33
            },
            {
                id: 37,
                label: 'MENUITEMS.SETUP.LIST.Users',
                link: 'setup/users',
                parentId: 33
            },
            {
                id: 38,
                label: 'MENUITEMS.SETUP.LIST.SalesTaxes',
                link: 'setup/taxes',
                parentId: 33
            },
            // {
            //     id: 39,
            //     label: 'MENUITEMS.SETUP.LIST.SubscriptionPlan',
            //     link: 'setup/SubscriptionPlan',
            //     parentId: 33
            // },

        ]
    },

        {
        id: 999,
        label: 'MENUITEMS.CONTACTUS.TEXT',
        icon: 'bx-support',
        link: 'javascript:void(0);',
        badge: {
            variant: 'info',
        }
    },
//     {
//         id: 46,
//         label: 'MENUITEMS.FINANCIALACCOUNTING.TEXT',
//         icon: 'bxs-bank',
//         subItems: [           
//             {
//                 id: 58,
//                 label: 'Financial Year',
//                 link: 'fa/financial-year',
//                 parentId: 46
//             },
//             {
//                 id: 49,
//                 label: 'MENUITEMS.FINANCIALACCOUNTING.LIST.Maingroup',
//                 link: 'fa/main-group',
//                 parentId: 46
//             },
//             {
//                 id: 55,
//                 label: 'MENUITEMS.FINANCIALACCOUNTING.LIST.Group',
//                 link: 'fa/group',
//                 parentId: 46
//             },
//             {
//                 id: 56,
//                 label: 'MENUITEMS.FINANCIALACCOUNTING.LIST.Ledger',
//                 link: 'fa/ledger',
//                 parentId: 46
//             },
//              {
//                 id: 47,
//                 label: 'MENUITEMS.FINANCIALACCOUNTING.LIST.Bank',
//                 link: 'fa/bank',
//                 parentId: 46
//             },
//             {
//                 id: 57,
//                 label: 'MENUITEMS.FINANCIALACCOUNTING.LIST.OpeningBalance',
//                 link: 'fa/openingbalance',
//                 parentId: 46
//             },
//             {
//                 id: 50,
//                 label: 'MENUITEMS.FINANCIALACCOUNTING.LIST.Narration',
//                 link: 'fa/narration',
//                 parentId: 46
//             },
//             {
//                 id: 51,
//                 label: 'MENUITEMS.FINANCIALACCOUNTING.LIST.Vouchers',
//                 link: 'fa/voucher',
//                 parentId: 46
//             },
//             {
//                 id: 51,
//                 label: 'MENUITEMS.FINANCIALACCOUNTING.LIST.VoucherHistory',
//                 link: 'fa/voucher-history',
//                 parentId: 46
//             },
//         ]
//     },
//     {
//     id: 60,
//     label: 'MENUITEMS.REPORTS.TEXT',
//     icon: 'bxs-bar-chart-alt-2',
//     subItems: [
//         {
//             id: 61,
//             label: 'MENUITEMS.REPORTS.LIST.DBook',
//             link: 'fa/DayBook',
//             parentId: 60
//         },
//         {
//             id: 62,
//             label: 'MENUITEMS.REPORTS.LIST.Ledger',
//             link: 'fa/ledger-reports',
//             parentId: 60
//         },
//         {
//             id: 63,
//             label: 'MENUITEMS.REPORTS.LIST.TrialBalance',
//             link: 'fa/trial-balance',
//             parentId: 60
//         },
//         {
//             id: 64,
//             label: 'MENUITEMS.REPORTS.LIST.BalanceSheet',
//             link: 'fa/balance-sheet',
//             parentId: 60
//         },
//         {
//             id: 65,
//             label: 'MENUITEMS.REPORTS.LIST.ProfitLoss',
//             link: 'fa/profit-loss',
//             parentId: 60
//         },
//         {
//             id: 66,
//             label: 'Import',   
//             link: 'fa/import',                       
//             parentId: 60
//         }
//     ]
// }



];
export const MENUForCashier: MenuItem[] = [
    // {
    //     id: 1,
    //     label: 'MENUITEMS.MENU.TEXT',
    //     isTitle: true
    // },
    {
        id: 2,
        label: 'MENUITEMS.HOME.TEXT',
        link: '/epage/dashboard',
        icon: 'bx-home-circle',


    },
    {
        id: 3,
        isLayout: true
    },
    {
        id: 4,
        label: 'MENUITEMS.SELL.TEXT',
        icon: 'bx-border-all',
        subItems: [
            {
                id: 5,
                label: 'MENUITEMS.SELL.LIST.DEFAULT',
                link: 'sell/webregister',
                parentId: 4
            },
            {
                id: 6,
                label: 'MENUITEMS.SELL.LIST.OPENCLOSE',
                link: 'sell/registerclose',
                parentId: 4
            },
            {
                id: 7,
                label: 'MENUITEMS.SELL.LIST.SELLHISTORY',
                link: 'sell/saleshistory',
                parentId: 4
            },
            {
                id: 8,
                label: 'MENUITEMS.SELL.LIST.SELLADVANCE',
                link: 'sell/selladvance',
                parentId: 4
            },
            {
                id: 9,
                label: 'MENUITEMS.SELL.LIST.SALESADVANCEHISTORY',
                link: 'sell/selladvancehistory',
                parentId: 4
            },

        ]
    },
    {
        id: 10,
        isLayout: true
    },
    {
        id: 11,
        label: 'MENUITEMS.KOT.TEXT',
        icon: 'bxs-store',
        subItems: [
            {
                id: 12,
                label: 'MENUITEMS.KOT.LIST.KOTDashboard',
                link: '/epage/dashboards/kot',
                parentId: 11
            },
            {
                id: 13,
                // label: 'MENUITEMS.SELL.LIST.KOT',
                label: 'MENUITEMS.KOT.LIST.KitchenOrderTicket',
                link: 'sell/kot',
                parentId: 11
            },
            {
                id: 14,
                // label: 'MENUITEMS.SELL.LIST.KOTHISTORY',
                label: 'MENUITEMS.KOT.LIST.KOTHistory',
                link: 'sell/kothistory',
                parentId: 11
            },
            {
                id: 15,
                label: 'MENUITEMS.KOT.LIST.TableMaster',
                link: 'setup/TableMaster',
                parentId: 11
            },

        ]
    },
    {
        id: 14,
        isLayout: true
    },
    {
        id: 15,
        label: 'MENUITEMS.CUSTOMERS.TEXT',
        icon: 'bxs-user-circle',
        subItems: [
            {
                id: 16,
                label: 'MENUITEMS.CUSTOMERS.LIST.Customers',
                link: 'customers/my-customer/0',
                parentId: 15
            },
        ]
    },
    {
        id: 999,
        label: 'MENUITEMS.CONTACTUS.TEXT',
        icon: 'bx-help-circle',
        link: 'javascript:void(0);',
        badge: {
            variant: 'info',
        }
    },


];
export const MENUForManager: MenuItem[] = [
    // {
    //     id: 1,
    //     label: 'MENUITEMS.MENU.TEXT',
    //     isTitle: true
    // },
    {
        id: 2,
        label: 'MENUITEMS.HOME.TEXT',
        link: '/epage/dashboard',
        icon: 'bx-home-circle',


    },
    {
        id: 3,
        isLayout: true
    },
    {
        id: 4,
        label: 'MENUITEMS.SELL.TEXT',
        icon: 'bx-border-all',
        subItems: [
            {
                id: 5,
                label: 'MENUITEMS.SELL.LIST.DEFAULT',
                link: 'sell/webregister',
                parentId: 4
            },
            {
                id: 6,
                label: 'MENUITEMS.SELL.LIST.OPENCLOSE',
                link: 'sell/registerclose',
                parentId: 4
            },
            {
                id: 7,
                label: 'MENUITEMS.SELL.LIST.SELLHISTORY',
                link: 'sell/saleshistory',
                parentId: 4
            },
            {
                id: 8,
                label: 'MENUITEMS.SELL.LIST.SELLADVANCE',
                link: 'sell/selladvance',
                parentId: 4
            },
            {
                id: 9,
                label: 'MENUITEMS.SELL.LIST.SALESADVANCEHISTORY',
                link: 'sell/selladvancehistory',
                parentId: 4
            },

        ]
    },
    {
        id: 10,
        isLayout: true
    },
    {
        id: 11,
        label: 'MENUITEMS.KOT.TEXT',
        icon: 'bxs-store',
        subItems: [
            {
                id: 12,
                label: 'MENUITEMS.KOT.LIST.KOTDashboard',
                link: '/epage/dashboards/kot',
                parentId: 11
            },
            {
                id: 13,
                // label: 'MENUITEMS.SELL.LIST.KOT',
                label: 'MENUITEMS.KOT.LIST.KitchenOrderTicket',
                link: 'sell/kot',
                parentId: 11
            },
            {
                id: 14,
                // label: 'MENUITEMS.SELL.LIST.KOTHISTORY',
                label: 'MENUITEMS.KOT.LIST.KOTHistory',
                link: 'sell/kothistory',
                parentId: 11
            },
            {
                id: 15,
                label: 'MENUITEMS.KOT.LIST.TableMaster',
                link: 'setup/TableMaster',
                parentId: 11
            },

        ]
    },
    {
        id: 16,
        isLayout: true
    },
    {
        id: 17,
        label: 'MENUITEMS.REPORTING.TEXT',
        icon: 'bxs-report',
        subItems: [
            {
                id: 18,
                label: 'MENUITEMS.REPORTING.LIST.RetailDashboard',
                link: 'reporting/dashboard',
                parentId: 17
            },
            {
                id: 19,
                label: 'MENUITEMS.REPORTING.LIST.SalesReports',
                link: 'reporting/salesreport',
                parentId: 17
            },
            {
                id: 20,
                label: 'MENUITEMS.REPORTING.LIST.InventoryReports',
                link: 'reporting/inventoryreport',
                parentId: 17
            },
            {
                id: 21,
                label: 'MENUITEMS.REPORTING.LIST.PaymentReports',
                link: 'reporting/paymentreport',
                parentId: 17
            },
            {
                id: 22,
                label: 'MENUITEMS.REPORTING.LIST.Mostfrequentlyproduct',
                link: 'reporting/mostfrequentlyproduct',
                parentId: 17
            },
            {
                id: 23,
                label: 'MENUITEMS.REPORTING.LIST.StoreCreditReports',
                link: 'reporting/storecreditreports',
                parentId: 17
            },
            {
                id: 24,
                label: 'MENUITEMS.REPORTING.LIST.RegisterClosures',
                link: 'reporting/registerclosure',
                parentId: 17
            },
            {
                id: 25,
                label: 'MENUITEMS.REPORTING.LIST.TaxReport',
                link: 'reporting/taxreport',
                parentId: 17
            }
        ]
    },
    {
        id: 26,
        isLayout: true
    },
    {
        id: 27,
        label: 'MENUITEMS.CATALOG.TEXT',
        icon: 'bx-menu',
        subItems: [
            {
                id: 28,
                label: 'MENUITEMS.CATALOG.LIST.Products',
                link: 'catalog/product',
                parentId: 27
            },
            {
                id: 29,
                label: 'MENUITEMS.CATALOG.LIST.Promotions',
                link: 'catalog/promotion',
                parentId: 27
            },

            {
                id: 30,
                label: 'MENUITEMS.CATALOG.LIST.Brands',
                link: 'catalog/brand',
                parentId: 27
            },
            {
                id: 31,
                label: 'MENUITEMS.CATALOG.LIST.Suppliers',
                link: 'catalog/supplier',
                parentId: 27
            },
            {
                id: 32,
                label: 'MENUITEMS.CATALOG.LIST.ProductTags',
                link: 'catalog/producttag',
                parentId: 27
            },
            {
                id: 33,
                label: 'MENUITEMS.CATALOG.LIST.ProductTypes',
                link: 'catalog/producttype',
                parentId: 27
            },
            {
                id: 34,
                label: 'MENUITEMS.CATALOG.LIST.Attribute',
                link: 'catalog/attribute',
                parentId: 27
            }

        ]
    },

    {
        id: 35,
        isLayout: true
    },
    {
        id: 36,
        label: 'MENUITEMS.INVENTORY.TEXT',
        icon: 'bxs-store',
        subItems: [
            {
                id: 37,
                label: 'MENUITEMS.INVENTORY.LIST.ReceiveStock',
                link: 'inventory/stock-control',
                parentId: 36
            },
            {
                id: 38,
                label: 'MENUITEMS.INVENTORY.LIST.Expense',
                link: 'inventory/expense',
                parentId: 36
            },
            {
                id: 39,
                label: 'MENUITEMS.INVENTORY.LIST.PurchaseDashboard',
                link: 'inventory/inventory-dashboard',
                parentId: 36
            },


        ]
    },
    {
        id: 40,
        isLayout: true
    },
    {
        id: 41,
        label: 'MENUITEMS.CUSTOMERS.TEXT',
        icon: 'bxs-user-circle',
        subItems: [
            {
                id: 42,
                label: 'MENUITEMS.CUSTOMERS.LIST.Customers',
                link: 'customers/my-customer/0',
                parentId: 41
            },
            {
                id: 43,
                label: 'MENUITEMS.CUSTOMERS.LIST.Groups',
                link: 'customers/customergroup',
                parentId: 41
            },

        ]
    },
    {
        id: 44,
        isLayout: true
    },
    {
        id: 45,
        label: 'MENUITEMS.SETUP.TEXT',
        icon: 'bxs-analyse',
        subItems: [
            // {
            //     id: 46,
            //     label: 'MENUITEMS.SETUP.LIST.Billing',
            //     link: 'setup/billing',
            //     parentId: 45
            // },
            {
                id: 47,
                label: 'MENUITEMS.SETUP.LIST.OutletsandRegisters',
                link: 'setup/outlets_and_registers',
                parentId: 45
            },
            {
                id: 48,
                label: 'MENUITEMS.SETUP.LIST.Users',
                link: 'setup/users',
                parentId: 45
            },
            // {
            //     id: 49,
            //     label: 'MENUITEMS.SETUP.LIST.SubscriptionPlan',
            //     link: 'setup/SubscriptionPlan',
            //     parentId: 45
            // },
        ]
    },
    // {
    //     id: 45,
    //     label: 'MENUITEMS.FINANCIALACCOUNTING.TEXT',
    //     icon: 'bxs-analyse',
    //     subItems: [
    //         {
    //             id: 46,
    //             label: 'MENUITEMS.FINANCIALACCOUNTING.LIST.Bank',
    //             link: 'fa/bank',
    //             parentId: 45
    //         },
    //     ]
    // },
    {
        id: 999,
        label: 'MENUITEMS.CONTACTUS.TEXT',
        icon: 'bx-help-circle',
        link: 'javascript:void(0);',
        badge: {
            variant: 'info',
        }
    },
];

